import LinkAuth from "./link-auth";

export default LinkAuth;